import { DEBUG_BUILD as t } from "./chunk895.js";
import { logger as a } from "./chunk815.js";
function p(e, r, o) {
  try {
    Object.defineProperty(e, r, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: o,
      writable: !0,
      configurable: !0
    });
  } catch {
    t && a.log(`Failed to add non-enumerable property "${r}" to object`, e);
  }
}
export {
  p as addNonEnumerableProperty
};
